import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import useAuthenticatedApiRequest from "../../AuthenticatedApiRequest";
import TchrURL from "../../TchrURL";
import { Invoice } from "../../types/billing";

type InvoicesQueryOptions = Omit<
  UseQueryOptions<Invoice[], Error, Invoice[], readonly ['invoices', string]>,
  'queryKey' | 'queryFn'
>;

const useInvoices = (customerId: string, { options }: { options: InvoicesQueryOptions }) => {
  const { get } = useAuthenticatedApiRequest();

  return useQuery({
    queryKey: ["invoices", customerId] as const,
    enabled: !!customerId && (options?.enabled ?? true),
    queryFn: async (): Promise<Invoice[]> => {
      const url = new TchrURL("/payment/invoices");
      const response = await get(url);

      if (response.status === 404 || response.status === 204) {
        return [];
      }
      if (!response.ok) {
        throw new Error(`Failed to fetch invoices (status ${response.status})`);
      }
      const data = (await response.json()) as Invoice[];
      return data;
    },
    ...options,
  });
};

export default useInvoices;
